import StoreFactory from '@kaidam/fc-shared/src/frontend/store'
import { Router } from 'router5'

import { reducer as auth } from './modules/auth'
import { reducer as payment } from './modules/payment'
import { reducer as fileupload } from '@kaidam/fc-frontend/src/store/modules/fileupload'

const appReducers = {
  auth,
  payment,
  fileupload,
}

interface StoreProps {
  router: Router<Record<string, any>>,
  initialState: Record<string, any>,
}

const Store = ({
  router,
  initialState = {},
}: StoreProps) => {
  
  return StoreFactory({
    router,
    initialState,
    reducers: appReducers,
  })
}

export default Store